import { Injectable } from "@angular/core";
import { UntilDestroy } from "@ngneat/until-destroy";
import { Store } from "@ngrx/store";
import { take } from "rxjs";
import { environment } from "src/environments/environment";
import { selectAuth } from "../store/selectors/auth.selectors";
import { isApp } from "../utils/functions/common.functions";
import { IRemoteXPACPortalState } from "../utils/interfaces/store.interfaces";

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class XpacProxyService {
  constructor(private store: Store<IRemoteXPACPortalState>) { }

  public open(xpacId: string, sameWindow: boolean = false): void {

    // first make default we will set the correct url in the if else
    let url = new URL("https://portal.crosspoint-cloud-dev.com/");
    if(!environment.production){
      url = new URL(`${environment.xpacProxyUrl}/${xpacId}`);
    }
    else{
      url = new URL(`${window.location.origin}${environment.xpacProxyUrl}/${xpacId}`);
    }

    console.log("url: " + url);
    // We want DEVEX to redirect to the service page when exiting, so provide that as the address
    url.searchParams.set("portal_address", `${window.location.origin}/service`);

    // The source is always the portal, even if
    // we come from the XPAC tooling. In that
    // case the window.xpact property should be
    // checked.
    url.searchParams.set("utm_source", "portal");

    // Add both the user-id and impersonator user-id
    // (if appropriate), so the XPAC proxy can make sure
    // it will use the same principal as the portal.
    try {
      this.store.select(selectAuth).pipe(take(1)).subscribe(auth => {
        url.searchParams.set("userId", auth.userData.userId);
        if (auth.userData.impersonator?.userId) {
          url.searchParams.set("impUserId", auth.userData.impersonator.userId);
          console.log("impUserId: " + auth.userData.impersonator.userId);
        }

        if (isApp() || sameWindow) {
          // navigate inside the current window (inside XPAC tooling)
          console.log("isApp should open window ");
          window.location.href = url.href;
        } else {
          // open inside a new window (normal browser)
          console.log("not isApp should stay in window ");
          window.open(url.href, '_blank');
        }
      });
    } catch (error) {
      console.log("Error while getting selectAuth : " + error);

      if (isApp() || sameWindow) {
        // navigate inside the current window (inside XPAC tooling)
        console.log("isApp should open window ");
        window.location.href = url.href;
      } else {
        // open inside a new window (normal browser)
        console.log("not isApp should stay in window ");
        window.open(url.href, '_blank');
      }

    }

  }
}
